/**
 * أسماءُ حالات الشراء بالعربيّة — <b>الرمزُ عقدٌ والنصُّ عرض</b>.
 *
 * ومفصولةٌ عن الشاشات لأنّ ثلاثَ شاشاتٍ تعرضها (الأوامر، الإيصالات، اللوحة)،
 * ونسخةٌ في كلٍّ منها تتفرّق عن أختها أوّلَ تعديل.
 */

/** ما قرّره إنسان. */
export const purchaseStatusNames: Record<string, string> = {
  DRAFT: 'مسوّدة',
  CONFIRMED: 'معتمَد',
  CANCELLED: 'ملغًى',
  CLOSED: 'مُغلَق',
}

/**
 * ما يقوله الحساب — <b>مشتقٌّ من سطور الإيصالات لا مخزَّن</b>.
 *
 * ولذلك يُعرض إلى جانب الحالة لا بدلًا منها: «معتمَد · مستلَمٌ جزئيًّا».
 */
export const receiptStateNames: Record<string, string> = {
  NOT_RECEIVED: 'لم يُستلَم',
  PARTIALLY_RECEIVED: 'مستلَمٌ جزئيًّا',
  FULLY_RECEIVED: 'اكتمل الاستلام',
}

export const receiptStatusNames: Record<string, string> = {
  DRAFT: 'مسوّدة',
  POSTED: 'مُرحَّل',
  REVERSED: 'معكوس',
}

/** أساسُ توزيع مصاريف الشحنة (ش-٤ §٦.٤) — ولكلٍّ متى يصدق. */
export const allocationBases = [
  { code: 'BY_VALUE', label: 'بالقيمة', hint: 'الجمركُ بالقيمة دائمًا، وهو الافتراض' },
  { code: 'BY_QTY', label: 'بالكميّة', hint: 'صناديقُ متماثلةٌ مختلفةُ القيمة' },
  { code: 'BY_WEIGHT', label: 'بالوزن', hint: 'الشحنُ الجوّيُّ — ويحتاج وزنَ كلّ صنف' },
] as const

/**
 * لونُ حالةِ الاستلام.
 *
 * و«اكتمل» ليس <b>أخضر</b> بل محايد: الاكتمالُ ليس إنجازًا يُهنَّأ عليه، وإنّما
 * انتهاءُ متابعة. والأخضرُ في هذه الشاشة يجب أن يبقى لما يحتاج انتباهًا.
 */
export function receiptStateTone(state: string): 'info' | 'warn' | 'ok' {
  return state === 'PARTIALLY_RECEIVED' ? 'warn' : 'info'
}

export const returnStatusNames: Record<string, string> = {
  DRAFT: 'مسوّدة',
  POSTED: 'مُرحَّل',
  REVERSED: 'معكوس',
}

export const adjustmentStatusNames: Record<string, string> = {
  DRAFT: 'مسوّدة',
  POSTED: 'مُرحَّلة',
  REVERSED: 'معكوسة',
}

/**
 * مراحلُ التحويل كما تُعرض — <b>ثلاثٌ ظاهرةٌ لا حالةٌ واحدة</b>.
 *
 * والموظّفُ يحتاج أن يرى أين وصل المستند: غادر؟ في الطريق؟ وصل؟ وحالةٌ واحدةٌ
 * مكتوبةٌ لا تقول أيّها.
 */
export const transferStatusNames: Record<string, string> = {
  DRAFT: 'مسوّدة',
  SHIPPED: 'في الطريق',
  RECEIVED: 'وصل',
  CANCELLED: 'ملغًى',
  REVERSED: 'معكوس',
}

/** المراحلُ الثلاثُ بترتيبها — لشريط التقدّم. */
export const transferStages = [
  { code: 'DRAFT', label: 'مسوّدة' },
  { code: 'SHIPPED', label: 'في الطريق' },
  { code: 'RECEIVED', label: 'وصل' },
] as const

/** أسماءُ أنواع الحركة بالعربيّة — الرمزُ عقدٌ والنصُّ عرض. */
export const movementTypeNames: Record<string, string> = {
  OPENING: 'رصيدٌ افتتاحيّ',
  PURCHASE: 'شراء',
  PURCHASE_RETURN: 'إرجاعٌ لمورّد',
  SALE: 'بيع',
  ADJUST_IN: 'تسويةُ زيادة',
  ADJUST_OUT: 'تسويةُ نقص',
  TRANSFER_OUT: 'خروجُ تحويل',
  TRANSFER_IN: 'دخولُ تحويل',
  REVERSAL: 'عكسُ حركة',
}

/** من أين جاءت الحركة — المستندُ الذي ولّدها. */
export const movementSourceNames: Record<string, string> = {
  SMART_INTAKE: 'إدخالٌ ذكيّ',
  GRN: 'إيصالُ استلام',
  RTS: 'إرجاعٌ لمورّد',
  ADJ: 'تسوية',
  TRF: 'تحويل',
  INVOICE: 'فاتورة',
}
